import { useTranslation } from "react-i18next";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { useState } from "react";
import css from "./UserSignature.module.css";

function ImportSignature({ handleSignDocChange, acceptFileType }) {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(false);

  const fileToBase64 = async (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });

  const importFile = async (e) => {
    const file = e?.target?.files[0];

    if (file) {
      const base64ImageStr = await fileToBase64(file);
      const fileType = file.type;

      setSelectedFile(file);
      handleSignDocChange({ base64ImageStr, fileType });
    }
  };

  return (
    <div className={css.signedDocumentWrapper}>
      <label htmlFor="signatureImage">
        <input
          type="file"
          name="signDoc"
          id="signatureImage"
          className={css.importFileInput}
          accept={acceptFileType ?? "image/png,image/jpg,image/jpeg,application/pdf"}
          onChange={importFile}
        />

        <div className={css.importSignFileWrapper}>
          <div>
            <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>{t("Choose File")}</ButtonComponent>
          </div>
          <span className={css.noFileChoosenText}>{!selectedFile ? "No File Chosen" : selectedFile.name}</span>
        </div>
      </label>
    </div>
  );
}

export default ImportSignature;
